import { useContext } from 'react';
import AuthContext from 'src/contexts/CookieAuthContext';

const useAuth = () => useContext(AuthContext);

export default useAuth;
